import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { DynamicWidgetDirective } from '@app/directives/dynamic-widget.directive';
import { CardSubtitleInput } from '@trackback/widgets';
import { AsyncPipe } from '@angular/common';
import { ParsePipe } from '@app/pipes/parse.pipe';
import { MatCardSubtitle } from '@angular/material/card';
import { WidgetInputBaseComponent } from '@app/widgets/widget-input-base.component';

@Component({
  selector: 'tb-card-subtitle',
  imports: [DynamicWidgetDirective, AsyncPipe, ParsePipe, MatCardSubtitle],
  template: `
    <mat-card-subtitle
      [class]="input().styleClasses | parse: context() | async"
    >
      @for (child of input().children; track $index) {
        <ng-container [dynamicWidget]="child" [context]="context()" />
      }
    </mat-card-subtitle>
  `,
  styles: `
    tb-card-subtitle {
      display: contents;
    }
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class CardSubtitleComponent extends WidgetInputBaseComponent<CardSubtitleInput> {}
